import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'lens_id' },
  { name: 'patent_citation.lens_id' },
  { name: 'patent_citation_count' },
  { name: 'external_id_type' },
  { name: 'doi' },
  { name: 'pmid' },
  { name: 'pmcid' },
  { name: 'magid' },
  { name: 'coreid' },
  { name: 'created' },
  { name: 'publication_type' },
  { name: 'publication_supplementary_type' },
  { name: 'author.collective_name' },
  { name: 'author.first_name' },
  { name: 'author.last_name' },
  { name: 'author.initials' },
  { name: 'author.display_name' },
  { name: 'author.magid' },
  { name: 'author.orcid' },
  { name: 'author.affiliation.name' },
  { name: 'author.affiliation.name.exact' },
  { name: 'author.affiliation.grid_id' },
  { name: 'author.affiliation.country_code' },
  { name: 'title' },
  { name: 'language' },
  { name: 'chemical.mesh_id' },
  { name: 'chemical.registry_number' },
  { name: 'chemical.substance_name' },
  { name: 'clinical_trial.id' },
  { name: 'clinical_trial.registry' },
  { name: 'field_of_study' },
  { name: 'abstract' },
  { name: 'full_text' },
  { name: 'date_published' },
  { name: 'year_published' },
  { name: 'conference.name' },
  { name: 'conference.instance' },
  { name: 'conference.location' },
  { name: 'author_count' },
  { name: 'reference_count' },
  { name: 'scholarly_citation_count' },
  { name: 'open_access.license' },
  { name: 'open_access.colour' },
  { name: 'source.title' },
  { name: 'source.title.exact' },
  { name: 'source.type' },
  { name: 'source.publisher' },
  { name: 'source.issn' },
  { name: 'source.country' },
  { name: 'source.asjc_codes' },
  { name: 'source.asjc_subjects' },
  { name: 'keyword' },
  { name: 'mesh_term.mesh_id' },
  { name: 'mesh_term.mesh_heading' },
  { name: 'mesh_term.qualifier_id' },
  { name: 'mesh_term.qualifier_name' },
  { name: 'funding.organisation' },
  { name: 'funding.organisation.exact' },
  { name: 'funding.funding_id' },
  { name: 'funding.country' }
]

const defaultSyntaxGuideUrl = 'https://support.lens.org/help-resources/basic-help/search-syntax/'

class LensEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('Lens Scholar')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://www.lens.org/lens/search/scholar/list?q=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default LensEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/LensEngine.js